import React from "react";
import { Navigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import styled from "styled-components";
import { usePermissions } from "../../contexts/PermissionsContext";

interface RequirePermissionProps {
  permission: string;
  children: React.ReactNode;
  redirectTo?: string;
}

const RequirePermission = ({
  permission,
  children,
  redirectTo = "/dashboard",
}: RequirePermissionProps) => {
  const { hasPermission, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <CenteredContainer>
        <CircularProgress size={40} />
      </CenteredContainer>
    );
  }

  if (!hasPermission(permission)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export default RequirePermission;
